import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IScanPackageToSwitchPodData } from '../../../types';

/**
 * This is to track the mutation key for scan package to switch pod.
 */
const MUT_SCAN_PACKAGE_TO_SWITCH_POD =
  'scan-package-to-switch-pod-mutation-key';

interface IScanPackageToSwitchPodMutation {
  onSuccess: (updatedData: IScanPackageToSwitchPodData) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for scanning a package to switch pod.
 */
export const useScanPackageToSwitchPodMutation = ({
  onSuccess,
  onError,
}: IScanPackageToSwitchPodMutation) => {
  const { isPending, isError, isSuccess, error, data, mutate, reset } =
    useMutation({
      mutationKey: [MUT_SCAN_PACKAGE_TO_SWITCH_POD],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.scanPackageToSwitchPod,
      onSuccess,
      onError,
    });

  return {
    data,
    error,
    isError,
    isPending,
    isScanPackageSuccess: isSuccess,
    resetScanPackageToSwitchPod: reset,
    scanPackageToSwitchPod: mutate,
  };
};
